import React from 'react';
import _ from 'lodash';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const ChiffreAffairesSection = ({ dashboardData, journalVenteData, billets }) => {
    const totalCATourisme = Number(dashboardData?.totalPaiementTourisme) || 0;

    // Utiliser les données du journal de vente pour la billetterie
    const billetterieJournal = journalVenteData || [];
    const billetterieFiltered = billetterieJournal.filter(item =>
        item.type_transaction === 'billetterie' ||
        item.service === 'billetterie' ||
        !item.type_transaction
    );
    const dataToUse = billetterieFiltered.length > 0 ? billetterieFiltered : billetterieJournal;

    const totalCABilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_vente) || Number(item.tarif) || 0)) || 0;
    const totalCAGlobal = totalCATourisme + totalCABilletterie;

    const totalDeboursTourisme = Number(dashboardData?.totalFraisTourisme) || 0;
    const totalDeboursBilletterie = Number(_.sumBy(dataToUse, (item) => Number(item.montant_achat) || Number(item.debours) || 0)) || 0;
    const totalDeboursGlobal = totalDeboursTourisme + totalDeboursBilletterie;

    const margeTourisme = totalCATourisme - totalDeboursTourisme;
    const margeBilletterie = totalCABilletterie - totalDeboursBilletterie;
    const margeGlobale = margeTourisme + margeBilletterie;

    const pourcentageTourisme = totalCAGlobal > 0 ? ((totalCATourisme / totalCAGlobal) * 100).toFixed(1) : 0;
    const pourcentageBilletterie = totalCAGlobal > 0 ? ((totalCABilletterie / totalCAGlobal) * 100).toFixed(1) : 0;
    const pourcentageMargeTourisme = totalCATourisme > 0 ? ((margeTourisme / totalCATourisme) * 100).toFixed(1) : 0;
    const pourcentageMargeBilletterie = totalCABilletterie > 0 ? ((margeBilletterie / totalCABilletterie) * 100).toFixed(1) : 0;
    const pourcentageMargeGlobale = totalCAGlobal > 0 ? ((margeGlobale / totalCAGlobal) * 100).toFixed(1) : 0;

    // Métriques supplémentaires
    const ticketMoyenBilletterie = (dataToUse?.length || 0) > 0 ? totalCABilletterie / dataToUse.length : 0;
    const activiteDominante = totalCATourisme > totalCABilletterie ? "TOURISME" : "BILLETTERIE";
    const pourcentageDominante = Math.max(parseFloat(pourcentageTourisme), parseFloat(pourcentageBilletterie));

    return (
        <div className="analysis-section">
            <SectionHeader
                title="💰 ANALYSE CHIFFRE D'AFFAIRES"
                pdfData={[
                    { metrique: "Tourisme", montant: totalCATourisme, pourcentage: `${pourcentageTourisme}%`, marge: margeTourisme },
                    { metrique: "Billetterie", montant: totalCABilletterie, pourcentage: `${pourcentageBilletterie}%`, marge: margeBilletterie }
                ]}
                pdfFilename="analyse-chiffre-affaires.pdf"
                pdfTitle="Analyse Chiffre d'Affaires"
                pdfTableHeaders={["Type Activité", "CA", "% du Total", "Marge"]}
            />

            <div className="table-container-prof">
                <div className="table-title-prof">REPARTITION CHIFFRE D'AFFAIRES PAR ACTIVITE</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">TYPE D'ACTIVITE</th>
                            <th className="text-right">CHIFFRE D'AFFAIRES</th>
                            <th className="text-right">DEBOURS</th>
                            <th className="text-right">MARGE</th>
                            <th className="text-right">% MARGE</th>
                            <th className="text-right">% DU CA TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>TOURISME</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCATourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeTourisme)}</td>
                            <td className="percentage-cell">{pourcentageMargeTourisme}%</td>
                            <td className="percentage-cell">{pourcentageTourisme}%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>BILLETTERIE</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCABilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursBilletterie)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeBilletterie)}</td>
                            <td className="percentage-cell">{pourcentageMargeBilletterie}%</td>
                            <td className="percentage-cell">{pourcentageBilletterie}%</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr className="total-row-prof">
                            <td className="text-left"><strong>TOTAL GLOBAL</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCAGlobal)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursGlobal)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeGlobale)}</td>
                            <td className="percentage-cell">{pourcentageMargeGlobale}%</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div className="table-container-prof">
                <div className="table-title-prof">METRIQUES CLES CHIFFRE D'AFFAIRES</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">INDICATEUR</th>
                            <th className="text-right">VALEUR</th>
                            <th className="text-left">COMMENTAIRE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>CA MOYEN PAR BILLET</strong></td>
                            <td className="currency-cell">{priceFormatterV3(ticketMoyenBilletterie)}</td>
                            <td className="text-left">Ticket moyen billetterie</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>NOMBRE DE TRANSACTIONS</strong></td>
                            <td className="number-cell">{billets?.length || 0}</td>
                            <td className="text-left">Total billets vendus</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>ACTIVITE DOMINANTE</strong></td>
                            <td className="percentage-cell">{activiteDominante}</td>
                            <td className="text-left">{pourcentageDominante.toFixed(1)}% du CA total</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>TAUX DE MARGE GLOBAL</strong></td>
                            <td className="percentage-cell">{pourcentageMargeGlobale}%</td>
                            <td className="text-left">Rentabilité globale</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ChiffreAffairesSection;
